document.querySelectorAll(".two-column-pdf__tab-title").forEach((tab) => {
    tab.addEventListener("click", () => {
        tab.parentElement.classList.toggle("active");
    });
});

document.querySelectorAll(".two-column-pdf__pill-item").forEach((pill) => {
    pill.addEventListener("click", () => {
        const language = pill.getAttribute("data-language");

        pill.parentElement.classList.remove("active");
        pill.parentElement.classList.remove("active-state-en");
        pill.parentElement.classList.remove("active-state-es");
        pill.parentElement.classList.add(`active-state-${language}`);
        document.querySelectorAll("[data-language-target]").forEach((item) => {
            item.classList.add("d-none");
        });
        document.querySelectorAll(`[data-language-target="${language}"]`).forEach((item) => {
            item.classList.remove("d-none");
        });
    });
});